import { render, staticRenderFns } from "./BigCommerceWebhooks.vue?vue&type=template&id=46a58346"
import script from "./BigCommerceWebhooks.vue?vue&type=script&lang=js"
export * from "./BigCommerceWebhooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports